import { IPaginationResponse } from 'dtos/pagination.dto';
import { IDealer } from 'interfaces/dealer.interface';
import useSWR from 'swr';

export default function useDealer(params?: {
  id?: number | null;
  queryStringify?: string | null;
  revalidateOnFocus?: boolean;
}) {
  const apiUrl = params?.queryStringify
    ? `${process.env.NEXT_PUBLIC_API_URL}/v1/public/dealers?${params.queryStringify}`
    : `${process.env.NEXT_PUBLIC_API_URL}/v1/public/dealers`;

  const {
    data,
    error: docsError,
    mutate: dataMutate,
  } = useSWR<IPaginationResponse<IDealer>>(
    !params?.id
      ? {
          url: apiUrl,
          method: 'GET',
        }
      : null,
    {
      revalidateOnFocus: params?.revalidateOnFocus || false,
    }
  );

  const {
    data: doc,
    error: docError,
    mutate: docMutate,
  } = useSWR<IDealer>(
    params?.id
      ? {
          url: `${process.env.NEXT_PUBLIC_API_URL}/v1/dealers/${params?.id}${
            params.queryStringify ? `?${params.queryStringify}` : ''
          }`,
          method: 'GET',
        }
      : null,
    {
      revalidateOnFocus: params?.revalidateOnFocus || false,
    }
  );

  return {
    data,
    doc,
    dataLoading: !docsError && !data,
    docsError,
    docLoading: !docError && !doc,
    docError,
    dataMutate,
    docMutate,
  };
}
